import { useState } from "react";

import { UsersIcon } from "lucide-react";

import { Icon } from "simplydo/react/ui/icon";

import { useAppSelector } from "store";
import util from "utils/utils";

import { TooltipButton } from "components/lib/UI";

import RequestJoinModal from "../../RequestJoinModal";
import type { IdeaWithTeamRequests } from "../types";

type JoinTeamActionProps = { idea: IdeaWithTeamRequests };

const JoinTeamAction = ({ idea }: JoinTeamActionProps) => {
  const [joinModalOpen, setJoinModalOpen] = useState(false);
  const user = useAppSelector((state) => state.user);

  if (!user || !idea) {
    return null;
  }

  if (util.canEditIdea(user, idea)) {
    return null;
  }

  if (idea?.ownerChallenge?.preventCollaboration) {
    return null;
  }

  return (
    <>
      <RequestJoinModal
        idea={idea}
        open={joinModalOpen}
        onClose={() => setJoinModalOpen(false)}
        onConfirm={() => {
          util.onUpdateIdea(idea, { requestedToJoin: true });
        }}
      />
      <TooltipButton
        disabled={idea.requestedToJoin}
        onClick={() => {
          setJoinModalOpen(true);
        }}
        tooltip={
          idea.requestedToJoin ? "Awaiting approval to join" : "Join team"
        }
        color={idea.requestedToJoin ? "secondary" : undefined}
      >
        <Icon icon={UsersIcon} />
      </TooltipButton>
    </>
  );
};

export default JoinTeamAction;
